exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n\n.CartPageLayout_container_1CI4N {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 0 2rem;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.CartPageLayout_button_27-No {\n  width: 20rem;\n  max-width: 80%;\n  margin-top: 2rem;\n}\n", ""]);

// exports
exports.locals = {
	"container": "CartPageLayout_container_1CI4N",
	"button": "CartPageLayout_button_27-No"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]_[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/CartPage/CartPageLayout.css
// module id = 996
// module chunks = 0